import React from 'react';
import { isCsr } from '@fe/armor_utils';
import { getUserInfo } from 'packages/common/bridge';
import { ConfigProvider } from '@fe/armor_component';
import { TUXProvider } from '@byted-tiktok/tux-components';
import { ErrorPage10019 } from '../ErrorPage/10019';
import { ErrorPage500 } from '../ErrorPage/500';
import { AppContext, AppLayoutPropsType, formatAppContext } from 'packages/common/app/app-layout';
import { captureMessage, setSlardrUserId } from 'packages/common/slardar';
export type ConfigLayoutPropsType = AppLayoutPropsType;

class ConfigLayout extends React.Component<ConfigLayoutPropsType> {
  errorCode = 0;
  configData: AppContext;

  constructor(props: ConfigLayoutPropsType) {
    super(props);
    this.configData = formatAppContext(props);

    if (isCsr() && this.configData.isInApp) {
      // init slardar_web_id for feedback track
      getUserInfo().then(user => {
        if (user.user_id) {
          setSlardrUserId(user.user_id);
        }
      });
    }
  }

  componentDidCatch(err: Error) {
    captureMessage(err);

    if (err.message === '10019') {
      this.errorCode = 10019;
    } else {
      this.errorCode = 500;
    }

    this.forceUpdate();
  }

  render() {
    return <ConfigProvider.ConfigContext.Provider value={this.configData}>
        <TUXProvider theme="light" dir={this.configData.dir} platform={this.configData.isIOS ? 'iOS' : 'Android'} hasStatusBar={this.configData.isInApp} androidStatusBarHeight={Number(this.configData.query.status_bar_height || 0)}>
          {this.errorCode ? this.errorCode === 10019 ? <ErrorPage10019 /> : <ErrorPage500 /> : this.props.children}
        </TUXProvider>
      </ConfigProvider.ConfigContext.Provider>;
  }

}

export default ConfigLayout;